import axios from 'axios';
import Qs from 'qs';
import { Loading, Message } from 'element-ui';
import config from '../config'; // 引入配置文件
import Cookies from 'js-cookie';

// 用于存储 store 实例
let store;

const ApiService = (() => {
    // 创建 Axios 实例
    const api = axios.create({
        baseURL: config.api.baseURL, // 使用配置文件中的 baseURL
        timeout: config.api.timeout, // 使用配置文件中的超时时间
    });

    let loadingInstance;

    // 添加请求拦截器
    api.interceptors.request.use(
        function (config) {
            // 在请求发送之前做一些处理，比如添加请求头等
            const token = Cookies.get('user_token');
            if (token) {
                config.headers['Authorization'] = `Bearer ${token}`;
            }

            if ((config.method === 'post' || config.method === 'put') && config.data) {
                config.headers['Content-Type'] = 'application/x-www-form-urlencoded';
                config.data = Qs.stringify(config.data); // 使用 Qs 库序列化数据
            }

            if (!config.noLoading) {
                // 使用 element-ui 的 Loading 组件
                loadingInstance = Loading.service({
                    lock: true,
                    text: 'Loading...',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
            }

            return config;
        },
        function (error) {
            return Promise.reject(error);
        }
    );

    // 添加响应拦截器
    api.interceptors.response.use(
        function (response) {
            if (loadingInstance) {
                loadingInstance.close();
            }

            if (response.status === 401) {
                if (store) {
                    store.dispatch('logout');
                } else {
                    console.error('store 实例未设置');
                }
            } else if (response.status === 500) {
                Message({
                    message: "网络错误",
                    type: 'error',
                });
                console.error('服务器错误', response);
            } else if (response.status === 200) {
                if (response.data.statecode === 401) {
                    if (store) {
                        store.dispatch('logout');
                    } else {
                        console.error('store 实例未设置');
                    }
                }
            }

            return response.data;
        },
        function (error) {
            if (loadingInstance) {
                loadingInstance.close();
            }
            Message({
                message: "网络错误",
                type: 'error',
            });

            return Promise.reject(error);
        }
    );

    function setRouter(vueStore) {
        store = vueStore;
    }

    function request(method, url, data = null, params = null, config = {}) {
        return api({
            method: method,
            url: url,
            data: data,
            params: params,
            ...config,
        });
    }

    function get(url, params = null, config = {}) {
        return request('get', url, null, params, config);
    }

    function post(url, data = null, params = null, config = {}) {
        return request('post', url, data, params, config);
    }

    return {
        get,
        post,
        setRouter,
    };
})();

export default ApiService;
